export const getFileNameFromUrl = (url: string) => {
  const urlParts = url.split('/');
  const fileName = urlParts[urlParts.length - 1];
  return fileName || 'document.pdf';
};

export const handleDownload = (fileName: string) => {
  const link = document.createElement('a');
  link.href = `${process.env.REACT_APP_PREFIX_PDF}/${fileName}`;
  link.target = '_blank';
  const pdfUrl = `${process.env.REACT_APP_PREFIX_PDF}/${fileName}`;
  link.download = getFileNameFromUrl(pdfUrl); // Usa el nombre extraído
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
